export const ADMIN_PWA_BADGE_REFRESH_EVENT = 'housecall-admin-badge-refresh';

export const requestAdminPwaBadgeRefresh = () => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new Event(ADMIN_PWA_BADGE_REFRESH_EVENT));
  }
};
